var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ea4335;}.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-3{fill:#4285f4;}.cls-4{fill:#34a853;}.cls-5{fill:#fbbc05;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4_stroke",
    "data-name": "4 stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_Chrome",
    "data-name": "Google Chrome"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.5,
    y: 6.5,
    width: 37,
    height: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google_Chrome-2",
    "data-name": "Google Chrome"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11,13a18.49,18.49,0,0,1,30.5,3.65H27.15c-2.58,0-4.25-.05-6,.9a8.49,8.49,0,0,0-4.29,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.85,25A6.15,6.15,0,1,0,25,18.85,6.15,6.15,0,0,0,18.85,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.38,33.05a8.28,8.28,0,0,1-9.7-3.93C16,26.21,11.53,18.43,9.5,14.9A18.52,18.52,0,0,0,21.41,43.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.71,18.85a8.43,8.43,0,0,1,1.55,10.36c-1.47,2.53-6.15,10.43-8.42,14.25a18.51,18.51,0,0,0,18.6-24.61Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevChrome);
export default __webpack_public_path__ + "static/media/Icon-Dev-Chrome.ee9f4ad5fca22ecac9b0de950d92ea49.svg";
export { ForwardRef as ReactComponent };